module.exports = __webpack_public_path__ + "img/grx_ios_ipa.4380204d.svg";